// TODO: This should be split into several, smaller components
import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { setHomePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { AppState } from 'src/common/redux/configure-store';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import TrainingModeWatermark from 'src/common/training-mode/training-mode-watermark';
import { styles } from './redeem-rewards-landing-styles';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { CartRewardData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { RedeemRewardsButtons, ProcessRedeemButtonsProps } from './redeem-rewards-buttons';

export const showRedeemRewardsLanding = (
  props: ProcessRewardsProps & ProcessRedeemButtonsProps,
): void => {
  setHomePage(<ProcessRedeemRewardsLanding {...props} />);
};

type Props = ProcessRedeemRewardsLandingStates & ProcessRewardsProps & ProcessRedeemButtonsProps;

const ProcessRedeemRewardsLandingPage: React.FC<Props> = ({
  notNowHandler,
  partialHandler,
  allHandler,
  trainingModeActive,
  reward,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const classes = styles();
  const trainingModeClasses = trainingModeStyles();
  const rewardAmount = reward?.redeemableLoyaltyProgram?.amount || 0;

  return (
    <Grid
      container
      direction='row'
      justifyContent='center'
      alignItems='flex-end'
      className={`fullHeight flexFull ${
        trainingModeActive ? trainingModeClasses.trainingModeBackground : classes.redeemContainer
      }`}
    >
      {trainingModeActive && (
        <TrainingModeWatermark
          dataTestId='process-tender-training-mode-watermark'
          supplementalStyles={trainingModeClasses.centerRedeemTrainingTradeMark}
        />
      )}

      <Grid item xs={6}>
        <Grid container direction='column' alignItems='center' justifyContent='center'>
          <Typography align='center' variant={'h2'} data-testid='redeem-rewards-title'>
            {t('RedeemRewards')}
          </Typography>

          <Typography className={classes.redeemRewardBar} />

          <Typography
            align='center'
            variant={'h4'}
            className={`${classes.redeemMarginBottom}`}
            data-testid='redeem-rewards-amount'
          >{`${convertCurrency(rewardAmount)}`}</Typography>
          <Typography variant={'body2'} className={`${classes.redeemInfoText}`}>
            {t('RewardsAmount')}
          </Typography>
          <Typography
            align='center'
            variant={'body1'}
            className={`${classes.redeemInfoText} ${classes.redeemMarginTop}`}
          >
            {t('RewardsAmount_SubMessage_Redeem')}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={7}>
        <Grid container direction='row'>
          <RedeemRewardsButtons {...{ notNowHandler, partialHandler, allHandler }} />
        </Grid>
      </Grid>
    </Grid>
  );
};

interface ProcessRewardsProps {
  reward?: CartRewardData;
}
interface ProcessRedeemRewardsLandingStates {
  isKeypadVisible: boolean;
  trainingModeActive: boolean;
}
const mapStateToProps = (state: AppState): ProcessRedeemRewardsLandingStates => ({
  isKeypadVisible: state.middleArea.salesKeypad,
  trainingModeActive: state.posMode.trainingMode,
});

const ProcessRedeemRewardsLanding = connect(mapStateToProps)(ProcessRedeemRewardsLandingPage);
export default ProcessRedeemRewardsLanding;
